import { noop } from '@sg/garnish';

// Not available in web application.
export const useInAppReview = () => {
  return noop;
};
